import { CloseIcon } from 'assets/icons/CloseIcon'
import { DropZone } from 'components/DropZone/DropZone'
import { Modal } from 'components/Modal/Modal'
import { getUsersSimpleInfo, importUsers } from 'features/users(Employees)/usersSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { getParams } from 'utils/helpers'

export const ImportEmployeesModal = ({ closeModal }: { closeModal: any }) => {
    const dispatch = useDispatch<AppDispatch>()
    useModalClose(closeModal)
    const [file, setFile] = useState<File>(null)

    const handleSave = async () => {
        const resp = await dispatch(importUsers(file))
        if (resp.meta.requestStatus === 'fulfilled') {
            await dispatch(getUsersSimpleInfo(getParams({ location })));
            closeModal()
        }
    }

    return <Modal black>
        <Flex column between center >
            <Flex mb='16' column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' > Import Employees</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex width='100%' justcenter column center gap='1rem' >
                    <BodyText style={{ marginTop: 30 }} >Import from file</BodyText>
                    <DropZone file={file} setFile={setFile} />
                </Flex>
            </Flex>
            <Button disabled={!file} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

